// extracted by mini-css-extract-plugin
module.exports = {"root":"AppTab_root_-oWI8","focusState":"AppTab_focusState_183TU"};